export default __webpack_public_path__ + "static/media/2 1.b39b9535.svg";